import Cookies from 'js-cookie'

export default function auth({ to, next, store }) {
  if (!store.getters['auth/token'] || !store.getters['auth/userId']) {
    Cookies.set('intended_url', to.path)
    return next({ name: 'login' })
  }
  return next()
}
